import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { AppShell } from '../components/AppShell';
import { Empty } from '../components/ui';

export function NotFoundPage() {
  const { t } = useTranslation('common');
  return (
    <AppShell>
      <Empty>
        <h1>{t('notFound.title')}</h1>
        <p>{t('notFound.body')}</p>
        <Link to="/">{t('notFound.home')}</Link>
      </Empty>
    </AppShell>
  );
}
